import { render } from "./TableHeaderSearch.vue?vue&type=template&id=650b6920&scoped=true"
import script from "./TableHeaderSearch.vue?vue&type=script&lang=js"
export * from "./TableHeaderSearch.vue?vue&type=script&lang=js"

import "./TableHeaderSearch.vue?vue&type=style&index=0&id=650b6920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650b6920"]])

export default __exports__